import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Checkbox, IconButton, TableCell, TableRow } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_COMMISSIONS_WRITE } from 'constants/rightsCodes';
import { useFieldDecimalPlacesConfig } from 'hooks';
import useConfirmDialog from 'features/common/components/confirm/useConfirmDialog';
import { leasingCommissionModalVar } from 'features/leasingCommission/variables';

const LeasingCommissionItemComponent = props => {
  const { t } = useTranslation();
  const canWrite = usePermission(ADMIN_COMMISSIONS_WRITE);
  const { cvsChPercent, cvsChAmount } = useFieldDecimalPlacesConfig();

  const { data, onItemsChanged } = props;
  const confirm = useConfirmDialog();

  const onDeleteItem = commissionId => {
    confirm(
      () => {
        onItemsChanged(commissionId);
      },
      {
        title: t('LeasingCommission.DeleteLeasingCommission'),
        content: t('LeasingCommission.AreYouSureDelete')
      },
      [confirm, t, onItemsChanged]
    );
  };

  return (
    <TableRow hover key={data.commissionId}>
      <TableCell>{data.commissionCode}</TableCell>
      <TableCell>{data.commissionName}</TableCell>
      <TableCell>{data.commissionPercent?.toFixed(cvsChPercent)}</TableCell>
      <TableCell>{data.commissionValue?.toFixed(cvsChAmount)}</TableCell>
      <TableCell>{data.assignToRole}</TableCell>
      <TableCell>{data.calcTypeName}</TableCell>
      <TableCell align='center'>
        <Checkbox checked={data.isReadOnly} size='small' disabled color='primary' />
      </TableCell>
      <TableCell align='center'>
        <Checkbox checked={data.isSubsidy} size='small' disabled color='primary' />
      </TableCell>
      <TableCell align='center'>
        <Checkbox checked={data.isCommission} size='small' disabled color='primary' />
      </TableCell>
      <TableCell align='right'>
        <Tooltip title={t('Edit')}>
          <IconButton
            color='primary'
            size='small'
            onClick={() =>
              leasingCommissionModalVar({
                open: true,
                item: {
                  commissionId: data.commissionId,
                  commissionCode: data.commissionCode,
                  commissionName: data.commissionName,
                  commissionPercent: data.commissionPercent,
                  commissionValue: data.commissionValue,
                  assignToRoleId: data.assignToRoleId,
                  isReadOnly: data.isReadOnly,
                  calcTypeId: data.calcTypeId,
                  isSubsidy: data.isSubsidy,
                  isCommission: data.isCommission
                }
              })
            }
          >
            <Edit />
          </IconButton>
        </Tooltip>
        <Tooltip title={t('Delete')}>
          <IconButton disabled={!canWrite} color='primary' size='small' onClick={() => onDeleteItem(data.commissionId)}>
            <Delete />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

LeasingCommissionItemComponent.propTypes = {
  data: PropTypes.object,
  onItemsChanged: PropTypes.func.isRequired
};

export default LeasingCommissionItemComponent;
